import { nanoid } from 'nanoid'
import { z, type ZodSchema, type ZodTypeDef } from 'zod'

import { nanoidSchema, slugify } from '@/utility'
import { randomThemeSlug } from '@scalar-org/random-slug'
/** Teams can have multiple theme definitions */
export type Theme = {
  uid: string
  /** Display name of the theme */
  name: string
  /** Description of the theme */
  description: string
  /** CSS string for the theme */
  theme: string
  /** Text identifier for the theme. Used for specifying in scalar.config.ts */
  slug: string
}

export const themeSchema = z.preprocess(
  (arg: any) => {
    if (!arg) return arg
    if (typeof arg === 'object') arg.identifier = slugify(arg.name)
    return arg
  },
  z.object({
    uid: nanoidSchema,
    name: z.string().transform(slugify),
    description: z.string(),
    theme: z.string(),
    slug: z.string().transform(slugify),
  }),
) satisfies ZodSchema<Theme, ZodTypeDef, any>

export const defaultTheme = (cssString = ''): Theme => ({
  uid: nanoid(),
  name: 'Default Theme',
  slug: randomThemeSlug(),
  description: '',
  theme: cssString,
})
